module.exports = __webpack_public_path__ + "img/twitch.55b2fb44.svg";